<template lang="pug">
  v-snackbar(
    :timeout="snackBar.timeout"
    top
    v-model="show"
  ) {{ text }}
    v-btn(
      v-if="snackBar.showCloseButton"
      flat
      class="pink--text"
      @click.native="close"
    ) Close
</template>

<script>
import { mapState } from 'vuex';
import * as types from '@/store/mutationTypes';

export default {
    name: 'SnackBar',

    data() {
        return {
            text: '',
            show: false
        };
    },

    computed: {
        ...mapState({
            snackBar: state => state.appearance.snackBar
        })
    },

    watch: {
        'snackBar.text': function snackBarText(newText) {
            if (newText && newText.length > 0) {
                this.show = true;
                this.text = this.snackBar.text;
                // NOTE: Setting the snackbar text to empty string is a workaround to reset the
                // snackbar if it timesout. Otherwise the watch event will not be set off.
                this.$store.commit(types.APPEARANCE_SET_SNACKBAR_TEXT, '');
            }
        }
    },

    methods: {
        close() {
            this.show = false;
            this.text = '';
            this.$store.commit(types.APPEARANCE_SET_SNACKBAR_TEXT, '');
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/core/SnackBar.vue